
export default {
  props: ["data"],
  mounted() {
    console.log(this.data, "3124323");
  },
};
